import { jsonApi } from '@models/jsonApi';

jsonApi.define('integrations/google-ads/user-list', {
  label: '',
  id: '',
  resourceName: '',
});
